export default "__VITE_ASSET__Dv3C2XSA__"